const isApplePlatform = (): boolean =>
  /Mac|iPhone|iPad|iPod/i.test(globalThis.window?.navigator?.userAgent ?? "");

/**
 * Platform-aware label for a Cmd/Ctrl + `key` shortcut, mirroring how the nav
 * search advertises "⌘K".
 *
 * Only call this from the client after mount (via `useModifierShortcutHint`).
 * Calling during SSR / first paint with a platform-specific return would
 * hydrate-mismatch on non-Apple devices (server used to default to `⌘G`).
 */
export const getModifierShortcutHint = (key: string): string =>
  isApplePlatform() ? `⌘${key.toUpperCase()}` : `Ctrl+${key.toUpperCase()}`;

/** The assistant dock shortcut, Cmd/Ctrl + G ("G for Gail"). */
export const getAssistantShortcutHint = (): string => getModifierShortcutHint("g");

/** Cmd/Ctrl + `key` with no other modifier, the shape every app-wide shortcut uses. */
export const isModifierShortcut = (event: KeyboardEvent, key: string): boolean =>
  (event.metaKey || event.ctrlKey) &&
  !event.shiftKey &&
  !event.altKey &&
  event.key.toLowerCase() === key;
